import { DashboardCard } from "./DashboardCard";
// ===== CHANGED FILE (was part of RecordsAndYearEndCard.tsx, now split
// into its own full card): Records of Employment (copy this whole file) =====
import { RecordsOfEmploymentData } from "../dashboardOverview.types";
import { RoeIcon } from "./DashboardIcons";

export interface RecordsOfEmploymentCardProps {
	data: RecordsOfEmploymentData;
	onIssueRoe?: (roeId: string) => void;
	onViewAll?: () => void;
}

export const RecordsOfEmploymentCard = ({ data, onIssueRoe, onViewAll }: RecordsOfEmploymentCardProps) => {
	return (
		<DashboardCard testId="records-of-employment-card">
			<div className="cd-card__header">
				<div className="cd-card__title">
					<RoeIcon />
					<h2>Records of Employment</h2>
				</div>
				<button type="button" className="cd-link-button" onClick={onViewAll}>
					All ROEs
				</button>
			</div>

			{data.readyToProcess.length > 0 && (
				<>
					<div className="cd-roe-section-label">READY TO SELF-PROCESS · {data.readyToProcessCount}</div>
					<div className="cd-roe-ready-list">
						{data.readyToProcess.map((item) => (
							<div className="cd-roe-ready" key={item.id}>
								<div className="cd-roe-ready__head">
									<span className="cd-roe-ready__name">{item.employeeName}</span>
									<span className="cd-badge cd-badge--warning">{item.daysLeft} days left</span>
								</div>
								<div className="cd-roe-ready__detail">
									{item.codeLabel} · {item.lastDayLabel}
								</div>
								<div className="cd-roe-ready__detail">{item.issueWithinLabel}</div>
								<button type="button" className="cd-roe-ready__action" onClick={() => onIssueRoe?.(item.id)}>
									Issue ROE &rarr;
								</button>
							</div>
						))}
					</div>
				</>
			)}

			{data.processedBySystem.length > 0 && (
				<>
					<div className="cd-roe-section-label cd-roe-section-label--muted">PROCESSED BY SIMPLEPAY</div>
					<div className="cd-roe-processed-list">
						{data.processedBySystem.map((item) => (
							<div className="cd-roe-processed" key={item.id}>
								<div>
									<div className="cd-roe-processed__name">{item.employeeName}</div>
									<div className="cd-roe-processed__detail">
										{item.codeLabel} · {item.issuedDateLabel}
									</div>
								</div>
								<span className="cd-roe-processed__number">{item.roeNumber}</span>
							</div>
						))}
					</div>
				</>
			)}
		</DashboardCard>
	);
};
